<script lang="ts">
  let props = $props()
  let { answer } = props
</script>

<div
  class="lg:ml-8 mt-2 border-l-2 border-dashed border-blue-800 px-4 lg:px-6 py-3 lg:py-6 bg-sky-50 rounded-r"
>
  {#if answer == 1}
    <p class="text-base lg:text-xl/8 text-gray-700">
      A: <span class="font-bold">“Are identical.”</span>
    </p>
    <p class="mt-4 text-sm lg:text-base/8 text-gray-700">
      This shows <span class="font-bold">mission-level alignment</span> - everyone’s
      steering in the same direction, with clarity and conviction.
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700">
      You’ve created a culture where strategy isn’t a secret - it’s shared,
      understood, and acted on.
    </p>
    <p
      class="mt-2 text-sm lg:text-base/8 text-gray-700 px-0 lg:px-10 italic font-semibold"
    >
      This is like every station on a Fast Attack sub knowing the current
      mission without being told twice - from the engine room to the bridge.
    </p>

    <p class="mt-6 text-base lg:text-lg/8 text-gray-700 font-bold">
      Level-Up Opportunity
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4">
      Ask: <span class="italic"
        >Are we just aligned at the headline level - or are our actions,
        metrics, and decision-making tied back to this priority?</span
      >
    </p>
    <p
      class="mt-1 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4 font-semibold"
    >
      Challenge your team to brief “mission updates” weekly, showing how their
      work is advancing the priority.
    </p>
  {:else if answer == 2}
    <p class="text-base lg:text-xl/8 text-gray-700">
      B: <span class="font-bold">“Mostly align.” </span>
    </p>
    <p class="mt-4 text-sm lg:text-base/8 text-gray-700">
      You’re close - but not precise.
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700">
      People may be pointing in the same general direction, but they’re
      navigating with different maps.
    </p>

    <p
      class="mt-2 text-sm lg:text-base/8 text-gray-700 px-0 lg:px-10 italic font-semibold"
    >
      On a submarine, if navigation, sonar, and weapons don’t agree on course,
      you may stay afloat - but you won’t hit the target.
    </p>

    <p class="mt-6 text-base lg:text-lg/8 text-gray-700 font-bold">
      Level-Up Opportunity
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4">
      Level-up from "mostly" to "fully" by over-communicating your #1 priority.
    </p>
    <p
      class="mt-1 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4 font-semibold"
    >
      Try a weekly “alignment pulse” - a single message, metric, or moment that
      reorients the team to what matters most right now.
    </p>
  {:else if answer == 3}
    <p class="text-base lg:text-xl/8 text-gray-700">
      C: <span class="font-bold">“Are all over the place.”</span>
    </p>
    <p class="mt-4 text-sm lg:text-base/8 text-gray-700">
      This reveals <span class="font-bold">a major drift from alignment.</span>
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700">
      There may be strategy up top, but it’s not translating down the line.
    </p>
    <p
      class="mt-2 text-sm lg:text-base/8 text-gray-700 px-0 lg:px-10 italic font-semibold"
    >
      If your crew has 5 different mission objectives, no one knows what to aim
      for - and that leads to wasted energy, missed opportunities, and internal
      friction.
    </p>

    <p class="mt-6 text-base lg:text-lg/8 text-gray-700 font-bold">
      Level-Up Opportunity
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4">
      Use your next all-hands or 1:1s to re-center. Ask: <span class="italic"
        >What do you think the top priority is - and how does your role support
        it?
      </span>
    </p>
    <p
      class="mt-1 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4 font-semibold"
    >
      This is your re-brief moment. Reconnect the team to the core mission -
      before momentum scatters further.
    </p>
  {:else if answer == 4}
    <p class="text-base lg:text-xl/8 text-gray-700">
      D: <span class="font-bold">“Start with, ‘Uh… I think it’s…’”</span>
    </p>
    <p class="mt-4 text-sm lg:text-base/8 text-gray-700">
      This is a <span class="font-bold">critical signal</span> - your team is operating
      without a compass.
    </p>

    <p
      class="mt-2 text-sm lg:text-base/8 text-gray-700 px-0 lg:px-10 italic font-semibold"
    >
      A submarine without a mission is just drifting below the surface - quiet,
      but not effective. And in business, drift leads to missed windows and
      burned-out crews.
    </p>

    <p class="mt-6 text-base lg:text-lg/8 text-gray-700 font-bold">
      Level-Up Opportunity
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4">
      It’s time for a full strategic reset. Re-establish the mission: what we’re
      doing, why it matters, and how every role connects.
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4">
      Print it. Speak it. Post it. Reiterate it until “I think” becomes “we
      know.”
    </p>
  {/if}
</div>
